module.exports = __webpack_public_path__ + "img/w4_feature_02.73ffb619.jpg";